const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 0C4.25442 0 0 4.36116 0 9.74016C0 14.0437 2.72175 17.6946 6.49721 18.9828C6.97142 19.0729 7.125 18.7709 7.125 18.5144V16.7011C4.48242 17.2904 3.93221 15.5518 3.93221 15.5518C3.49996 14.426 2.87692 14.1265 2.87692 14.1265C2.01479 13.5218 2.94263 13.5348 2.94263 13.5348C3.89658 13.6029 4.3985 14.5388 4.3985 14.5388C5.24558 16.0274 6.62071 15.5972 7.163 15.3481C7.24771 14.719 7.49392 14.2888 7.76625 14.0461C5.65646 13.7986 3.43821 12.9633 3.43821 9.23205C3.43821 8.16794 3.8095 7.29944 4.41671 6.61763C4.31854 6.37169 3.99317 5.38063 4.50933 4.03973C4.50933 4.03973 5.30733 3.77837 7.12262 5.0381C7.88025 4.82219 8.6925 4.71424 9.5 4.71018C10.3075 4.71424 11.1205 4.82219 11.8798 5.0381C13.6935 3.77837 14.4899 4.03973 14.4899 4.03973C15.0068 5.38144 14.6815 6.3725 14.5833 6.61763C15.1929 7.29944 15.561 8.16875 15.561 9.23205C15.561 12.9731 13.3388 13.7969 11.2235 14.038C11.5639 14.34 11.875 14.9325 11.875 15.8416V18.5144C11.875 18.7734 12.027 19.0777 12.5091 18.982C16.2814 17.6922 19 14.0421 19 9.74016C19 4.36116 14.7464 0 9.5 0Z",
  fill: "url(#paint0_linear)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -0.818056,
  y1: -6.94537,
  x2: 19.7913,
  y2: -6.76624,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.122751,
  stopColor: "#0F62FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6B5BD2"
})));
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a38d4cf3fb417f6f1d0c7c0f5eb6a77e.svg";
export { ForwardRef as ReactComponent };